import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) Selfcity, Inc.
 * All rights reserved.
 */
import * as React from "react";
import { use } from "@bluelibs/x-ui";
import InboxTasksFilterTag from "./InboxTasksFilterTag";
import { InboxTagsCollection } from "@bundles/UIAppBundle/collections";
/**
 * InboxTasksFiltersTags.
 */
function InboxTasksFiltersTags({ inboxTasksFiltersCount, onTagToggle, }) {
    const [checkedTagId, setCheckedTagId] = React.useState(null);
    const inboxTagsCollection = use(InboxTagsCollection);
    const { data: tagsList, loading, refetch, error, } = inboxTagsCollection.useQuery({
        body: {
            _id: 1,
            name: 1,
        },
        queryInput: {
            filters: {},
        },
    });
    const sortedList = [...tagsList].sort((inboxTagA, inboxTagB) => (inboxTagA.name < inboxTagB.name ? -1 : 1));
    return (_jsx("div", { className: "inbox-tasks-tags-container", children: !loading &&
            sortedList.map((inboxTag) => {
                var _a;
                return (_jsx(InboxTasksFilterTag, { id: inboxTag._id, title: inboxTag.name, reachedDueDateTasks: inboxTasksFiltersCount[inboxTag._id].reachedDueDateTasks, tasksTotalNumber: inboxTasksFiltersCount[inboxTag._id].tasksTotalNumber, checked: ((_a = inboxTag._id) === null || _a === void 0 ? void 0 : _a.toString()) === (checkedTagId === null || checkedTagId === void 0 ? void 0 : checkedTagId.toString()), onTagToggle: (tagId, checked) => checked
                        ? (setCheckedTagId(tagId), onTagToggle(tagId))
                        : (setCheckedTagId(undefined), onTagToggle(undefined)) }));
            }) }));
}
export default React.memo(InboxTasksFiltersTags);
